
import React from 'react';
import EditPackagePaymentSettingComponent from '../../../Components/PackagePaymentSetting/EditPackagePaymentSetting';

export default function EditPackagePaymentSetting() {
    return (
        <div className='page-body'>
            <EditPackagePaymentSettingComponent />
        </div>
    );
}